import React from "react";
import "./styles/buildProfile.css";
export const BuildProfile = ({onNext}) => {
  return (
    <div className="buildProfileCard">
      <div className="buildProfileCardInner">
        <div className="buildProfileheader">
          Building Your Personalized Financial Experience
        </div>
        <div className="buildProfilepara" style={{ marginTop: "1rem" }}>
          <div>
            We believe managing your finances should be straightforward and
            relevant to your specific situation. The profile questions we ask
            help us understand where you are in your financial journey and what
            matters most to you right now.
            <span>
             {" "}By learning about your goals, challenges, and preferences, we can
              create a personalized dashboard that:
            </span>
            <ul style={{ listStyle: "inside", marginBottom: "1rem" }}>
              <li className="buildProfileparaList">
                Highlights the financial information that's most important to
                you
              </li>
              <li className="buildProfileparaList">
                Removes unnecessary distractions and irrelevant features
              </li>
              <li className="buildProfileparaList">
                Delivers personalized insights that align with your financial
                objectives
              </li>
              <li className="buildProfileparaList">
                {" "}
                Adjusts the level of guidance and educational content to match
                your experience
              </li>
              <li className="buildProfileparaList">
                Shows tools and resources that fit your current needs
              </li>
            </ul>
          </div>
        </div>
        <div className="buildProfilepara" style={{ marginTop: "1rem" }}>
          <span className="buildProfileparablue">
            We understand that everyone's financial situation is unique. Instead
            of showing you everything at once, we'll focus on what's meaningful
            for you. As your needs change, your experience can evolve with you –
            just update your profile answers at any time.
          </span>
        </div>
        <div className="buildProfilepara" style={{ marginTop: "1rem" }}>
          <span className="buildProfileparablue">
            Your responses help us automatically create personalized options for
            your dashboard that are relevant to where you are in your financial
            journey. This makes it easier to stay on top of your finances and
            work toward your goals.
          </span>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <button
            className="savebutton"
            style={{
              textAlign: "center",
              marginTop: "2rem",
              fontSize: "18px",
              padding: "12px 40px",
            }}
            type="submit"
            onClick={onNext}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};
